// 消息推送
export default {
    time: 'время',
    startTime: 'Дата начала',
    endTime: 'Дата окончания',
    to: 'к',
    userName: 'Название аккаунта',
    roleName: 'Имя роли',
    operate: 'действовать',
    department: 'отделение',
    personName: 'учетная запись',
    select: 'пожалуйста, выберите',
    role: 'Роль',
}
